import Vue from 'vue';
import Router from 'vue-router';
import * as R from 'ramda';
// import {Message} from 'element-ui';

import store from '@/store';
import {TASK_STATUS} from '@/config/enum';

import OrderSearch from '@/view/OrderSearch';
import OrderCreate from '@/view/OrderCreate';
import AgentOrderCreate from '@/view/AgentOrderCreate';
import AdminOrderCreate from '@/view/AdminOrderCreate';
import AdminScorePoint from '@/view/AdminScorePoint';
import WorkerScorePoint from '@/view/WorkerScorePoint';
import OrderView from '@/view/OrderView';
import AgentManage from '@/view/AgentManage';
import HospitalManage from '@/view/HospitalManage';
import DepartmentEdit from '@/view/DepartmentEdit';
import AgentEdit from '@/view/AgentEdit';
import DepartmentManage from '@/view/DepartmentManage';
import AccountAdd from '@/view/AccountAdd';
import AgentAccountAdd from '@/view/AgentAccountAdd';
import Login from '@/view/Login';
import FindPass from '@/view/FindPass';
import Register from '@/view/Register';
import ResetPass from '@/view/ResetPass';
import DownloadLog from '@/view/LogAudit/DownloadLog';
import StlConfig from '@/view/stlConfig';
import refund from '@/view/refund';
// import StlConfigAdd from '@/view/StlConfig/add';
// import MultipleError from '@/view/LogAudit/MultipleError';
import IPError from '@/view/LogAudit/IPError';
import AgentMoneyDetail from '@/view/AgentMoneyDetail';

import {
  agentAllFilter,
  agentAllTable,
  departmentAllFilter,
  departmentAllTable,
  hospitalAllFilter,
  hospitalAllTable,
  ipAllFilter,
  ipAllTable,
  logAuditAllFilter,
  logAuditAllTable,
  orderAllFilter,
  orderAllFilterInner,
  orderAllTable,
  orderAllTableInner,
  orderFinishedFilter,
  orderFinishedInnerFilter,
  orderFinishedInnerTable,
  orderFinishedTable,
  orderProcessingFilter,
  orderProcessingInnerFilter,
  orderProcessingInnerTable,
  orderProcessingTable,
  orderSubmitedFilter,
  orderSubmitedInnerFilter,
  orderSubmitedInnerTable,
  orderSubmitedTable,
  orderUnsubmitFilter,
  orderUnsubmitInnerFilter,
  orderUnsubmitInnerTable,
  orderUnsubmitTable,
  refundAllFilter,
  refundAllTable,
  stlConfigAllFilter,
  stlConfigAllTable
} from './config';

import {openHandler} from './func';

Vue.use(Router);

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      fullscreen: true,
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: {
      fullscreen: true,
    },
  },
  {
    path: '/findPass',
    name: 'FindPass',
    component: FindPass,
    meta: {
      fullscreen: true,
    },
  },
  {
    path: '/activePass',
    name: 'ActivePass',
    component: FindPass,
    meta: {
      fullscreen: true,
    },
  },
  {
    path: '/resetPass',
    name: 'ResetPass',
    component: ResetPass,
    meta: {
      fullscreen: true,
    },
  },
  {
    path: '/order/all',
    name: 'OrderAll',
    component: OrderSearch,
    meta: {
      keepAlive: true,
      orderList: true,
      keepCache: false,
      orderFilter: orderAllFilter,
      orderTable: orderAllTable,
      fetchDataName: 'fetchAll',
      operates: [
        {
          label: '打开',
          onClick: openHandler.OrderAll,
        },
      ],
    },
  },
  {
    path: '/order/all_inner',
    name: 'OrderAllInner',
    component: OrderSearch,
    meta: {
      keepAlive: true,
      orderList: true,
      keepCache: false,
      orderFilter: orderAllFilterInner,
      orderTable: orderAllTableInner,
      fetchDataName: 'fetchAll',
      operates: [
        {
          label: '打开',
          onClick: openHandler.OrderAll,
        },
      ],
    },
  },
  // 待提交
  {
    path: '/order/unsubmit',
    name: 'OrderUnsubmit',
    component: OrderSearch,
    meta: {
      keepAlive: true,
      orderList: true,
      keepCache: false,
      orderFilter: orderUnsubmitFilter,
      orderTable: orderUnsubmitTable,
      fetchDataName: 'fetchDraft',
      status: TASK_STATUS.UNSUBMIT,
      operates: [
        {
          label: '打开',
          onClick: openHandler.OrderUnsubmit,
        }
      ],
    },
  },
  {
    path: '/order/unsubmit/detail/:id',
    name: 'OrderUnsubmitDetail',
    component: OrderCreate,
  },
  {
    path: '/order/unsubmit_inner',
    name: 'OrderUnsubmitInner',
    component: OrderSearch,
    meta: {
      keepAlive: true,
      orderList: true,
      keepCache: false,
      orderFilter: orderUnsubmitInnerFilter,
      orderTable: orderUnsubmitInnerTable,
      fetchDataName: 'fetchDraft',
      status: TASK_STATUS.UNSUBMIT,
      operates: [
        {
          label: '打开',
          onClick: openHandler.OrderUnsubmit,
        }
      ],
    },
  },
  // 处理中
  {
    path: '/order/processing',
    name: 'OrderProcessing',
    component: OrderSearch,
    meta: {
      keepAlive: true,
      orderList: true,
      keepCache: false,
      orderFilter: orderProcessingFilter,
      orderTable: orderProcessingTable,
      fetchDataName: 'fetchProcessing',
      status: TASK_STATUS.PROCESSING,
      operates: [
        {
          label: '打开',
          onClick: openHandler.OrderProcessing,
        }
        // , {
        //   label: '分配',
        //   onClick: openHandler.OrderAllot,
        // },
      ],
    },
  },
  {
    path: '/order/processing_inner',
    name: 'OrderProcessingInner',
    component: OrderSearch,
    meta: {
      keepAlive: true,
      orderList: true,
      keepCache: false,
      orderFilter: orderProcessingInnerFilter,
      orderTable: orderProcessingInnerTable,
      fetchDataName: 'fetchProcessing',
      status: TASK_STATUS.PROCESSING,
      operates: [
        {
          label: '打开',
          onClick: openHandler.OrderProcessing,
        }
        // , {
        //   label: '分配',
        //   onClick: openHandler.OrderAllotGroup,
        // },
      ],
    },
  },
  // 已提交
  {
    path: '/order/submited',
    name: 'OrderSubmited',
    component: OrderSearch,
    meta: {
      keepAlive: true,
      orderList: true,
      keepCache: false,
      orderFilter: orderSubmitedFilter,
      orderTable: orderSubmitedTable,
      fetchDataName: 'fetchSubmitted',
      status: TASK_STATUS.SUBMITED,
      operates: [
        {
          label: '打开',
          onClick: openHandler.OrderSubmited,
        },
      ],
    },
  },
  {
    path: '/order/submited_inner',
    name: 'OrderSubmitedInner',
    component: OrderSearch,
    meta: {
      keepAlive: true,
      orderList: true,
      keepCache: false,
      orderFilter: orderSubmitedInnerFilter,
      orderTable: orderSubmitedInnerTable,
      fetchDataName: 'fetchSubmitted',
      status: TASK_STATUS.SUBMITED,
      operates: [
        {
          label: '打开',
          onClick: openHandler.OrderSubmited,
        },
      ],
    },
  },
  // 已完成
  {
    path: '/order/finished',
    name: 'OrderFinished',
    component: OrderSearch,
    meta: {
      keepAlive: true,
      orderList: true,
      keepCache: false,
      orderFilter: orderFinishedFilter,
      orderTable: orderFinishedTable,
      fetchDataName: 'fetchFinished',
      status: TASK_STATUS.FINISHED,
      operates: [
        {
          label: '打开',
          onClick: openHandler.OrderFinished,
        },
        // {
        //   label: '修改负责人',
        //   onClick: openHandler.OrderAllot,
        // },
        {
          label: '查看模型',
          onClick: openHandler.OrderOpenStl,
        },
      ],
    },
  },
  {
    path: '/order/finished_inner',
    name: 'OrderFinishedInner',
    component: OrderSearch,
    meta: {
      keepAlive: true,
      orderList: true,
      keepCache: false,
      orderFilter: orderFinishedInnerFilter,
      orderTable: orderFinishedInnerTable,
      fetchDataName: 'fetchFinished',
      status: TASK_STATUS.FINISHED,
      operates: [
        {
          label: '打开',
          onClick: openHandler.OrderFinished,
        }
        // , {
        //   label: '修改重建组',
        //   onClick: openHandler.OrderEditAllotGroup,
        // },
      ],
    },
  },

  {
    path: '/order/detail/:id',
    name: 'OrderDetail',
    component: OrderView,
  },
  // 创建订单
  {
    path: '/order/create',
    name: 'OrderCreate',
    component: OrderCreate,
  },
  {
    path: '/agent/order/create',
    name: 'AgentOrderCreate',
    component: AgentOrderCreate
  },
  {
    path: '/order/admincreate',
    name: 'AdminOrderCreate',
    component: AdminOrderCreate
  },
  {
    path: '/order/adminscorepoint',
    name: 'AdminScorePoint',
    component: AdminScorePoint
  },
  {
    path: '/order/workerscorepoint',
    name: 'WorkerScorePoint',
    component: WorkerScorePoint
  },
  {
    path: '/account/department/edit/:id',
    name: 'DepartmentEdit',
    component: DepartmentEdit,
  },

  // 代理商编辑
  {
    path: '/account/agent/edit/:id',
    name: 'AgentEdit',
    component: AgentEdit,
  },

  // 代理商医院科室管理
  {
    path: '/agent/department/manage',
    name: 'AgentDepartmentManage',
    component: DepartmentManage,
    meta: {
      departmentAllFilter,
      departmentAllTable,
      fetchDataName: 'departmentListName',
    },
  },

  // 代理商账号添加
  {
    path: '/agent/account/add',
    name: 'AgentAccountAdd',
    component: AgentAccountAdd
  },

  // 代理商账单详情
  {
    path: '/agent/financelist',
    name: 'AgentMoneyDetail',
    component: AgentMoneyDetail
  },

  // 科室管理
  {
    path: '/account/department/manage',
    name: 'Department',
    component: DepartmentManage,
    meta: {
      departmentAllFilter,
      departmentAllTable,
      fetchDataName: 'departmentListName',
    },
  },
  // 代理商管理
  {
    path: '/account/agent/manage',
    name: 'Agent',
    component: AgentManage,
    meta: {
      agentAllFilter,
      agentAllTable,
      fetchDataName: 'agentList',
    },
  },
  // 医院管理
  {
    path: '/account/hospital/manage',
    name: 'Hospital',
    component: HospitalManage,
    meta: {
      hospitalAllFilter,
      hospitalAllTable,
      fetchDataName: 'hospitalListName',
    },
  },

  // 账号添加
  {
    path: '/account/add',
    name: 'Add',
    component: AccountAdd,
    meta: {
      departmentAllFilter,
      departmentAllTable,
      fetchDataName: 'fetchAll',
    },
  },

  // 下载异常
  {
    path: '/log/download',
    name: 'DownloadLog',
    component: DownloadLog,
    meta: {
      logAuditAllFilter,
      logAuditAllTable,
      fetchDataName: 'logList',
    },
  },

  // ip异常
  {
    path: '/log/ip',
    name: 'IPError',
    component: IPError,
    meta: {
      ipAllFilter,
      ipAllTable,
      fetchDataName: 'logList',
    },
  },

  // 模型配置
  {
    path: '/stlConfig/list',
    name: 'StlConfig',
    component: StlConfig,
    meta: {
      stlConfigAllFilter,
      stlConfigAllTable,
      fetchDataName: 'stlConfigList',
    },
  },
  // 退款
  {
    path: '/refund/list',
    name: 'refund',
    component: refund,
    meta: {
      refundAllFilter,
      refundAllTable,
      fetchDataName: 'refundList',
    },
  },

  // {
  //   path: '/stlConfig/add',
  //   name: 'StlConfigAdd',
  //   component: StlConfigAdd,
  // },
  // {
  //   path: '/stlConfig/edit/:id',
  //   name: 'StlConfigEdit',
  //   component: StlConfigAdd,
  // },
  // 多人异常
  // {
  //   path: '/log/multiple',
  //   name: 'MultipleError',
  //   component: MultipleError,
  //   meta: {
  //     logAuditAllFilter,
  //     logAuditAllTable,
  //     fetchDataName: 'fetchAll',
  //   },
  // },
];

const router = new Router({
  routes,
});

router.beforeEach(async(to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  const list = store.getters['rbac/flattenRbacList'];
  // console.log(list);

  if (list.length > 0) {
    if (!R.equals(to.name, 'Login') &&
      !R.equals(to.name, 'Register') &&
      !R.equals(to.name, 'FindPass') &&
      !R.equals(to.name, 'ActivePass') &&
      !R.equals(to.name, 'ResetPass') &&
      !R.any(R.propEq('path', to.name))(list)) {
      if (to.path !== '/') {
        console.error('您没该页面的权限，如需访问，请向管理员申请');
      }
      next({name: R.prop('path', R.head(list))});
      return;
    } else if (to.path === '/') {
      next({name: R.prop('path', R.head(list))});
    }
  }

  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js